import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ReactHtmlParser from 'react-html-parser';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ConfirmGlobalChange.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ConfirmGlobalChange extends Component {
    toggleConfirmGlobalChange = () => {
        this.props.toggleConfirmGlobalChange();
    }

	toggle = () => {
        this.toggleConfirmGlobalChange(false);
    }

	componentWillMount() {
        this.setState({
			modal: this.props.isConfirmGlobalChangeOpen
		});
    }
    
    componentWillReceiveProps() {
        this.setState({
			modal: this.props.isConfirmGlobalChangeOpen
		});
	}

	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isConfirmGlobalChangeOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.toggle}>{strings.title}</ModalHeader>
		          	<ModalBody>
                        {ReactHtmlParser(strings.description)}
		          	</ModalBody>
                    <ModalFooter className="justify-content-center">
                        <button
                            className="showtix-button showtix-background__primary-1"
                            onClick={this.toggle}>
                            {strings.ok}
                        </button>
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

ConfirmGlobalChange.propTypes = {
    isConfirmGlobalChangeOpen: PropTypes.bool,
    toggleConfirmGlobalChange: PropTypes.func
}

export default ConfirmGlobalChange;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/ConfirmGlobalChange/ConfirmGlobalChange.js